import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import { Breadcrumb } from '../../../../components/Breadcrumb';
import { PageHeader } from '../../../../components/PageHeader';
import { createCustomer } from '../../models';
import { getDisplayError } from '../../../../utils/get-display-error';
import { CreateCustomerForm } from '../../components/CreateCustomerForm';
import { PageHeading } from 'components/PageHeading';
import { captureException } from '@sentry/react';
import { trackEvent } from '../../../../utils/track-event';

const CreateCustomerPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <PageHeader title="Nieuwe klant" />

      <PageHeading
        leftSide={
          <Breadcrumb
            parentItem={{
              name: 'Klanten',
              to: '/internal/customers',
            }}
            currentItem="Nieuwe klant"
          />
        }
      />

      <div className="px-4">
        <CreateCustomerForm
          onSubmit={async (inputData) => {
            try {
              const created = await createCustomer(inputData);
              trackEvent('customer_created', {
                customer_id: created.id,
                country: inputData.country,
              });
              navigate(`../${created.id}/general`, { replace: true });
              toast.success('Klant aangemaakt');
            } catch (err: any) {
              captureException(err);
              toast.error('Kon klant niet aanmaken: ' + getDisplayError(err));
            }
          }}
        />
      </div>
    </>
  );
};

export default CreateCustomerPage;
